import { render } from "./knowledge-demo.vue?vue&type=template&id=4a0b1a7d&scoped=true"
import script from "./knowledge-demo.vue?vue&type=script&lang=js"
export * from "./knowledge-demo.vue?vue&type=script&lang=js"

import "./knowledge-demo.vue?vue&type=style&index=0&id=4a0b1a7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0b1a7d"]])

export default __exports__